(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_f7dee22"] && !Shopify.designMode) return;
  try {
    function filterArtistDirectory(input) {
    const directory = input.parentElement.parentElement;
    const grid = directory.querySelector('[data-directory-grid]');
    const emptyMessage = directory.querySelector('[data-directory-empty]');
    if (!grid || !emptyMessage) return;

    const cards = Array.from(grid.querySelectorAll('[data-artist-card]'));
    const query = input.value.trim().toLocaleLowerCase();
    let matches = 0;

    cards.forEach((card) => {
      const name = (card.dataset.artistName || '').toLocaleLowerCase();
      const visible = name.startsWith(query);
      card.hidden = !visible;
      card.style.display = visible ? '' : 'none';
      if (visible) matches += 1;
    });

    emptyMessage.hidden = matches !== 0;
  }

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-directory-search]')) {
      filterArtistDirectory(event.target);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
